import React from 'react'
import { BsFacebook, BsInstagram, BsTwitter } from 'react-icons/bs';
import { FaTiktok } from 'react-icons/fa';
import logo from '../assets/logo.png';

export default function Footer() {

  const links = [
    {
      title: "About",
      data: ["About", "Terms", "Legal"],},
    {
      title: "NFT",
      data: ["OpenSea", "Maker", "Learn"],
    },
    {
      title: "Contact",
      data: ["Press", "Support"],
    },
    {
      title: "Social",
      data: ["Twitter", "Instagram"],
    },
  ]

  const socialLinks = [
    <BsFacebook />,
    <BsTwitter />,
    <BsInstagram />,
    <FaTiktok />
  ]

  return (
    <footer className='footer'>
      <div className="upper">
        <div className="brand-container">
          <div className="brand">
            <img src={logo} alt="logo" />
          </div>
          <p>Lorem ipsum dolor sit amet.</p>
          <ul>
            {
              socialLinks.map((socialLink,index)=>
              <li key={index}> {socialLink} </li>)
            }
          </ul>
        </div>
        <div className="links">
          {
            links.map(({title,data},index)=> {
              return (
                <div className="link" key={index}>
                  <h4>{title}</h4>
                  <ul>
                    {
                      data.map((linksData,index)=>
                        <li key={index}><a href="#">{linksData}</a></li>
                      )
                    }
                  </ul>
                </div>
              )
            })
          }
        </div>
      </div>
      <div className="lower">
        <span>&copy; Copyright 2022 Harish Kumar</span>
      </div>
    </footer>
  )
}
